import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=4dc7ff01&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"
import style0 from "./VideoCard.vue?vue&type=style&index=0&id=4dc7ff01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc7ff01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc7ff01')) {
      api.createRecord('4dc7ff01', component.options)
    } else {
      api.reload('4dc7ff01', component.options)
    }
    module.hot.accept("./VideoCard.vue?vue&type=template&id=4dc7ff01&scoped=true", function () {
      api.rerender('4dc7ff01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/VideoCard.vue"
export default component.exports